import { render, staticRenderFns } from "./QuestionTypes.vue?vue&type=template&id=946e33da&scoped=true"
import script from "./QuestionTypes.vue?vue&type=script&lang=js"
export * from "./QuestionTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "946e33da",
  null
  
)

export default component.exports